module.exports = __webpack_public_path__ + "fonts/trust_sans_bold_it-webfont.645058ee.woff";